<template>

  <list :columns="columns" :modalCreate="modalCreate" :removeLink="removeLink" :cardLink="cardLink" :isUpdate="true"
    :isAdd="true" :itemLink="itemLink" :setLink="setLink" :openItem="false" :fields="fields" :params="params"
    :searchDisable="true" @change="change" @changeFunction="changeFunction" v-model="val" />

</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) { },
    change(val) { },
  },
  props: ['id'],
  created() {
    this.itemLink += `/${this.id}/systems`;
    this.setLink += `/${this.id}/systems`;
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "field",
      fields: [
        {
          col: ' col-12 col-md-12',
          key: "key",
          label: "Введите ID партнера",
          type: "field",
          textType: 'text'
        },
        {
          col: ' col-12 col-md-12',
          key: "system",
          label: "Выберите систему",
          type: "select",
          modal: "system",
          selectKey:'name'
        },
      
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_system_key",
      itemLink: "shops",
      setLink: "shops",
      columns: [

        {
          key: "system",
          title: "Система",
          object: "name",
          checkbox: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "key",
          title: "PARTNER ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
